import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import * as instructorActions from '../_actions/roster.actions';
import * as actionTypeActions from '../_actions/actiontype.actions';
// import * as userActions from '../_actions/user.actions';
import { userActions } from '../_actions/user.actions';
import CalendarWithContainer from './../components/calendar/BigCalendar.C';
import MyRoster from '../components/calendar/MyRostert';
import CustomSpinner from '../components/common/CustomSpinner' ;
import { withCookies } from "react-cookie";

class ETimeContainers extends React.Component {
  state = {
    activeTab: 'myCalendar',
    readOnly: false
  };
  componentDidMount() {
    this.props.dispatch(userActions.employeeLogin(184563));

    this.props.actions.actionTypeActions.fetchActionTypes();
    
    this.setState({ mounted: true });

    const user = JSON.parse(localStorage.getItem("user"));
    if (user.role !== 0) {
      this.setState({ readOnly: true });
    }

    this.props.actions.etimeActions.fetchCurrentUserETime(user);
  }

  toggle = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  };

  render() {
    const { readOnly } = this.state;
    return (
      <div className="container">
        <div className="content-heading clearfix">
          {/* <div className="CPlogo" /> */}
          <div className="heading-left">
            <h1 className="page-title">Calendar</h1>
            <p className="page-subtitle">ETime Calendar</p>
          </div>
        </div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'myCalendar'
              })}
              onClick={() => {
                this.toggle('myCalendar');
              }}
            >
              myCalendar
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTab === 'myRoster'
              })}
              onClick={() => {
                this.toggle('myRoster');
              }}
            >
              myRoster
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="myCalendar">
            {this.props.loading ? <CustomSpinner/> :
              <CalendarWithContainer
                events={this.props.events}
                actions={this.props.actions}
                readOnly={readOnly}
              />
            }
          </TabPane>
          <TabPane tabId="myRoster">
            {this.state.mounted && (
              <MyRoster
                events={this.props.events}
                actions={this.props.actions}
              />
            )}
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { loading: state.etime.loading, events: state.etime.events };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      etimeActions: bindActionCreators(instructorActions, dispatch),
      actionTypeActions: bindActionCreators(actionTypeActions, dispatch),
      // userActions: bindActionCreators(userActions, dispatch)
    },
    dispatch
  };
}

export default withCookies(connect(mapStateToProps, mapDispatchToProps)(ETimeContainers));
